import { useRef, useState } from "react";

import { useLayout } from "app/context/LayoutContext/hooks";
import { useElementSize } from "app/hooks/general";

import { NavigationContainer } from "./styles";
import {
  NavigationTopbar,
  NavigationSidebar,
  NavigationBackdrop,
  AnnouncementBar,
} from "./components";

export default function Navigation() {
  const containerRef = useRef(null);

  const [showSidebar, setShowSidebar] = useState(false);

  const { setTopBarHeight } = useLayout();

  useElementSize(containerRef, {
    onUpdate(size) {
      setTopBarHeight(size.height);
    },
  });

  function toggleShowSidebar() {
    setShowSidebar(!showSidebar);
  }

  return (
    <>
      <NavigationContainer>
        <NavigationTopbar toggleShowSidebar={toggleShowSidebar} />

        <AnnouncementBar />

        <NavigationSidebar show={showSidebar} toggleShow={toggleShowSidebar} />
      </NavigationContainer>

      <NavigationBackdrop
        show={showSidebar}
        toggleShowSidebar={toggleShowSidebar}
      />
    </>
  );
}
